import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { SearchInput, mock } from '@forma/forma-ui-kit';
import ColumnButton from './ColumnButton';

import { ITemplateTableTotalRow } from 'interfaces/templates.interface';

import styles from './products-table-select-modal.module.css';

interface TableRowsSelectProps {
  total: ITemplateTableTotalRow[],
  onSelect: (data: { id: string, name: string, width?: string }) => void,
  onDeselect: (id: string) => void,
  showTotalRow: boolean,
  onSetTotalRow: (checked: boolean) => void,
}

const TableRowsSelect = ({ total, onSelect, onDeselect, showTotalRow, onSetTotalRow }: TableRowsSelectProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>('');

  const filteredTotal = search.length ? total.filter(row => row.name.toLowerCase().includes(search.toLowerCase())) : total;
  const filteredMock = search.length ? (
    mock.productTableFooter.filter(row => row.name.toLowerCase().includes(search.toLowerCase()))
  ) : mock.productTableFooter;

  return (
    <div className={classNames(styles.block, styles.right)}>
      <div className={styles.subtitle}>{t('rows_of_totals')}</div>
      <div className={styles.search}>
        <SearchInput
          className={styles.searchInput}
          placeholder={t('uikit:search')}
          onSearch={setSearch}
        />
      </div>
      <div className={styles.columns}>
        {(filteredTotal.length || showTotalRow) ? (
          <>
            {filteredTotal.map(row => (
              <ColumnButton
                data={row}
                onRemove={() => onDeselect(row.id)}
                checked
                key={row.id}
              />
            ))}
            {showTotalRow && (
              <ColumnButton
                data={{
                  id: 'total',
                  name: 'Итоги прописью',
                }}
                onRemove={() => onSetTotalRow(false)}
                checked
              />
            )}
          </>
        ) : (
          <div className={styles.columnsEmpty}>{t('select_rows')}</div>
        )}
      </div>
      <div className={styles.tabs}>
        <div className={styles.columns}>
          {filteredMock.map(row => {
            if (total.find(({ id }) => row.id === id)) return null;
            return (
              <ColumnButton
                data={row}
                onClick={() => onSelect({ id: row.id, name: row.name })}
                key={row.id}
              />
            );
          })}
          {!showTotalRow && (
            <ColumnButton
              data={{
                id: 'total',
                name: 'Итоги прописью',
              }}
              onClick={() => onSetTotalRow(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TableRowsSelect;
